/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconFileInfo = createReactComponent("outline", "file-info", "IconFileInfo", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M11 14h1v4h1", "key": "svg-2" }], ["path", { "d": "M12 11h.01", "key": "svg-3" }]]);

export { IconFileInfo as default };
//# sourceMappingURL=IconFileInfo.mjs.map
